import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateTema } from '../../hooks/temi'
import TemaForm from '../../components/TemaForm'

export default function TemaCreate() {
  const createTema = useCreateTema()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/temi">Temi</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <TemaForm
          save={async (tema) => {
            const savedTema = await createTema.mutateAsync(tema)
            navigate(`/temi/${savedTema.id}`)
          }}
        />
      </div>
    </Page>
  )
}
